import {
  GET_PENDING_APPLICATIONS,
  GET_PENDING_APPLICATIONS_SUCCESS,
  GET_PENDING_APPLICATIONS_ERROR,
  APPROVE_PERMIT_APPLICATION,
  APPROVE_PERMIT_APPLICATION_SUCCESS,
  APPROVE_PERMIT_APPLICATION_ERROR,
  APPROVE_APPLICATION_CAPACITY_ERROR,
  CLEAR_CAPACITY_ERROR,
  DENY_PERMIT_APPLICATION,
  DENY_PERMIT_APPLICATION_SUCCESS,
  DENY_PERMIT_APPLICATION_ERROR,
  OVERRIDE_PARKING_CAPACITY,
  OVERRIDE_PARKING_CAPACITY_SUCCESS,
  OVERRIDE_PARKING_CAPACITY_ERROR,
} from './types';

const initialState = {
  pendingApplications: [],
  pendingLoading: false,
  approving: false,
  approveError: null,
  capacityError: false,
  denying: false,
  denyError: null,
  capacityOverrideLoading: false,
  capacityOverrideError: null,
};

const permitApplicationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PENDING_APPLICATIONS:
      return {
        ...state,
        pendingLoading: true,
        error: null,
      };
    case GET_PENDING_APPLICATIONS_SUCCESS:
      return {
        ...state,
        pendingLoading: false,
        pendingApplications: payload,
      };
    case GET_PENDING_APPLICATIONS_ERROR:
      return {
        ...state,
        pendingLoading: false,
        error: 'Failed to fetch pending applications',
      };
    case APPROVE_PERMIT_APPLICATION:
      return {
        ...state,
        approving: true,
        approveError: null,
      };
    case APPROVE_PERMIT_APPLICATION_SUCCESS:
      return {
        ...state,
        approving: false,
        pendingApplications: state.pendingApplications.filter(
          (app) => app.parkingPermitApplicationID !== payload.parkingPermitApplicationID
        ),
      };
    case APPROVE_PERMIT_APPLICATION_ERROR:
      return {
        ...state,
        approving: false,
        approveError: 'Failed to approve application',
      };
    case APPROVE_APPLICATION_CAPACITY_ERROR:
      return {
        ...state,
        approving: false,
        capacityError: true,
      };
    case CLEAR_CAPACITY_ERROR:
      return {
        ...state,
        capacityError: false,
      };
    case DENY_PERMIT_APPLICATION:
      return {
        ...state,
        denying: true,
        denyError: null,
      };
    case DENY_PERMIT_APPLICATION_SUCCESS:
      return {
        ...state,
        denying: false,
        pendingApplications: state.pendingApplications.filter(
          (app) => app.parkingPermitApplicationID !== payload.parkingPermitApplicationID
        ),
      };
    case DENY_PERMIT_APPLICATION_ERROR:
      return {
        ...state,
        denying: false,
        denyError: 'Failed to deny application',
      };
    case OVERRIDE_PARKING_CAPACITY:
      return {
        ...state,
        capacityOverrideLoading: true,
        capacityOverrideError: null,
      };
    case OVERRIDE_PARKING_CAPACITY_SUCCESS:
      return {
        ...state,
        capacityOverrideLoading: false,
        pendingApplications: state.pendingApplications.filter(
          (app) => app.parkingPermitApplicationID !== payload.parkingPermitApplicationID
        ),
      };
    case OVERRIDE_PARKING_CAPACITY_ERROR:
      return {
        ...state,
        capacityOverrideLoading: false,
        capacityOverrideError: 'Failed to override capacity',
      };
    default:
      return state;
  }
};

export default permitApplicationsReducer;
